// zzz for automatic sort to end
const TEMPORARY_ID_PREFIX = 'zzzTEMP_'
let nextTemporaryId = 1

export const getTemporaryMessageId = () => `${TEMPORARY_ID_PREFIX}${nextTemporaryId++}`

export const isMessagePending = (id: string) => id.startsWith(TEMPORARY_ID_PREFIX)
